<template>
<div class="invoice-result">
    <!--  // the line witch puts the class for not-paid invoices ( the next line 6 must be repleced with the bottom line )
         <v-row :class="[(item.paid === true) ? 'paid' : 'not-paid', 'im-result']"> -->
    <v-row class="im-result" no-gutters>
        <v-col cols="8" md="6">
            <v-row align="center" no-gutters>
                <v-col cols="12" md="6">
                    <div class="body-2 px-2 font-weight-bold text-truncate">
                        {{ item.merchant_info.name }}
                    </div>
                    <div class="px-2">
                        {{ item.merchant_info.fiscal_code }}
                    </div>
                </v-col>
                <v-col cols="12" md="6">
                    <div class="body-2 px-2 font-weight-bold text-truncate">
                        {{ item.customer_info.name }}
                    </div>
                    <div class="px-2">
                        {{ item.customer_info.fiscal_code }}
                    </div>
                </v-col>
            </v-row>
        </v-col>
        <v-col cols="4" md="6">
            <v-row no-gutters>
                <v-col cols="12" md="6" class="text-center">
                    <div class="body-2 font-weight-bold text-truncate">
                        {{ item.number }}
                    </div>
                    <div>
                        {{ formatDate(item.issued_at) }}
                    </div>
                </v-col>
                <v-col cols="12" md="6" class="text-right">
                    <div class="pa-2">
                        <im-price :price="item.total" />
                    </div>
                </v-col>
            </v-row>
        </v-col>
    </v-row>

</div>
</template>


<script>
import defaults from "../utils/PropDefaults.js"
import IMPrice from "../small-components/IMPrice.vue";

export default {
    name: `reservations`,
    components: {
        "im-price": IMPrice
    },
    props: {
        item: {
            type: Object,
            default: defaults.invoice_item
        },
    },

    methods: {
        formatDate(date) {
            if(!date) return date;
            return this.$moment(String(date))
                .format('DD MMM YYYY');
        },

        emitClick() {
            this.$emit("click");
        }
    }
};
</script>

<style>
.paid {
    border-left: 5px solid #4caf50;
}

.not-paid {
    border-left: 5px solid #f44336;
    background-color: #ffebee;
}
</style>
